import { useAuth0 } from '@auth0/auth0-react';
import { useStore } from '../store';
import { invalidateSession, useSession } from '../lib/session';
export function useAuth() {
  const { isAuthenticated, isLoading, logout: auth0Logout } = useAuth0();
  const store = useStore();
  const session = useSession();
  return {
    ...store,
    user: store.user,
    isAuthenticated: isAuthenticated || session.status === 'ready',
    isLoading,
    logout: async () => {
      invalidateSession();
      if (isAuthenticated)
        await auth0Logout({
          logoutParams: { returnTo: window.location.origin + '/login' },
        });
    },
  };
}
